/* terminos y condiciones si hay un link en la descrip */
import { useState, useEffect } from 'react';

export const useTermsAndConditions = (descripcion) => {
  const [tieneLink, setTieneLink] = useState(false);
  const [checkboxChecked, setCheckboxChecked] = useState(false);

  function contieneLink(descripcion) {
    if (!descripcion) return false;

    const parser = new DOMParser();
    const doc = parser.parseFromString(descripcion, "text/html");
    const enlaces = doc.getElementsByTagName("a");

    return enlaces.length > 0;
  }

  useEffect(() => {
    const resultado = contieneLink(descripcion);
    setTieneLink(resultado);
    setCheckboxChecked(false);
  }, [descripcion]);

  const handleCheckboxChange = () => {
    setCheckboxChecked(!checkboxChecked);
  };

  return {
    tieneLink,
    checkboxChecked,
    handleCheckboxChange
  };
};